<template>
	<SOSlotModal
		:modal-id="pageSetting.modalId"
		:modal-title="canDelete ? pageSetting.modalTitle.canDelete : pageSetting.modalTitle.cannotDelete"
		@close="close"
	>
		<template v-slot:modal-body>
			<div v-if="canDelete">
				<div class="f-regular f-16 f-c-black">
					Yakin ingin menghapus rekening <b>{{ rekeningBankDetail.nama }}</b>? Data keuangan akan tetap
					tersimpan, namun data mesin tidak dapat dikembalikan.
				</div>
				<SOInputCheckbox
					:checkboxes="jenisLayananReguler"
					:checked="setuju"
					@selected="selected"
				/>
			</div>
			<div v-else>
				<div class="f-regular f-16 f-c-black">
					Tidak dapat menghapus, karena rekening ini terhubung dengan mesin EDC:
				</div>
				<ul class="f-semi f-16 f-c-black">
					<li>Shopee Pay (Real Wash)</li>
					<li>Gopay (Real Wash)</li>
				</ul>
				<div class="f-regular f-14 f-c-black">
					Ubah tujuan settlement mesin EDC tersebut ke rekening lain untuk menghapus rekening ini.
				</div>
			</div>
		</template>

		<template v-slot:modal-footer>
			<SOButton
				:text="'Hapus rekening ini'"
				:outline-danger="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled || !setuju"
				:loading="pageSetting.btn.save.loading"
				@action="deleteRekening"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "RekeningBankModalHapus",
	components: {
		SOSlotModal,
		SOInputCheckbox,
		SOButton,
	},
	props: {
		canDelete: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			rekeningBankDetail: "getRekeningBankDetail",
		}),
	},
	data() {
		return {
			pageSetting: {
				modalTitle: {
					cannotDelete: "Tidak dapat menghapus",
					canDelete: "Hapus rekening"
				},
				modalId: "modal-rekening-bank-hapus",
				btn: {
					save: {
						loading: false,
						disabled: false,
					}
				}
			},
			setuju: false,
			jenisLayananReguler: {
				name: "setuju",
				data: [
					{
						id: "setuju",
						value: "1",
						title: "Ya, saya ingin menghapus rekening ini.",
						checked: false,
						titleBold: false,
					},
				]
			},
		}
	},
	mounted() {
		$("#" + this.pageSetting.modalId).modal("show");
	},
	methods: {
		selected(val) {
			this.setuju = val
		},
		close() {
			$("#" + this.pageSetting.modalId).modal("hide");
			setTimeout(() => {
				this.$router.back()
			}, 300)
		},
		async deleteRekening() {
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankDelete", this.rekeningBankDetail.idakun_keuangan)
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.$toast.success(res.msg)
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			await this.$router.push({name: "RekeningBank.List"})
		}
	},
}
</script>